import React from 'react'
import { kudzuPlusTrueFun } from '../../../../../../../helpers/utils/Utils'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ConfirmationModuleSubItem = ({ data }) => {
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const { t } = useTranslation();

  return (
    <>
      {data.value &&
        <div className='flex flex-col justify-center md:pt-16 pt-10'>
          <p className={`font-hanken-grotesk text-[var(--addAccount-text)] uppercase 
 lg:text-[13px] md:text-[12px] sm:text-[12px] text-[13px] 
 font-[600] tracking-[2px] md:pb-8 pb-4 ${kudzuPlusTrue ? '': 'opacity-[50%]' }
 `}>{data.title}</p>
          <p className='font-hanken-grotesk text-[var(--transferSubHeading-text)] lg:text-[16px] md:text-[15px] 
 sm:text-[13px] text-[13px] font-[500]'>{data.title === t("amount") ? `$ ${data.value}` : data.value}</p>
        </div>
      }

    </>


  )
}

export default ConfirmationModuleSubItem